import React from "react";
import { Icon } from "react-feather";

export type PositionType = "USE_TEMPLATE" | "START" | "END" | "INLINE";

interface PositionDropdownProps {
  Icon: Icon;
  value: string;
  options: { value: PositionType; label: string }[];
  onChange: (value: string) => void;
  color?: string;
  hoverColor?:
    | "hover:badge-primary"
    | "hover:badge-secondary"
    | "hover:badge-accent";
  width?: "w-24" | "w-32" | "w-36";
}

export function PositionDropdown({
  Icon,
  value,
  options,
  onChange,
  color = "badge-neutral",
  hoverColor = "hover:badge-accent",
  width = "w-36",
}: PositionDropdownProps) {
  const handleChange = (newValue: string) => {
    onChange(newValue);
    // Close dropdown by removing focus
    (document.activeElement as HTMLElement)?.blur();
  };

  const getDisplayValue = () => {
    const option = options.find((opt) => opt.value === value);
    return option?.label || options[0]?.label || value;
  };

  return (
    <div className="form-control">
      <div className="dropdown dropdown-end">
        <div
          tabIndex={0}
          role="button"
          className={`badge badge-sm ${color} cursor-pointer ${hoverColor}`}
        >
          <Icon size={14} /> {getDisplayValue()}
        </div>
        <ul
          tabIndex={0}
          className={`dropdown-content menu bg-base-100 rounded-box z-[1] ${width} p-2 shadow`}
        >
          {options.map((option) => (
            <li key={option.value}>
              <button type="button" onClick={() => handleChange(option.value)}>
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
